import React, { useState, useEffect } from "react";
import "./popup.scss";
import Cross from "../../assets/images/Cross.svg";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { dispatchSelectAddress } from "../../store/reducers/AddressReducer";
import { axiosInstance } from "../../Axios";

const AllAddressPopup = (props) => {
  // const selectAdd = useSelector((state) => state.selectAddress);
  const dispatch = useDispatch();
  const [clicked, setClicked] = useState();

  const [Data, setData] = useState([]);
  const ACCtoken = useSelector((state) => state.ACCtoken);
  useEffect(() => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    config.headers['AUTHORIZATION'] = ACCtoken;
    axiosInstance
      .get("v2/user/address/get/", config)
      .then((res) => {
        setData(res.data.data);
      });
  }, []);
  const select = useSelector((state) => state.selectAdress.isSelected);
  useEffect(() => {
    dispatch(dispatchSelectAddress());
  });



  return props.trigger ? (
    <div className="Main-PoupupDiv allADD">
      <div className="PopupMainCon ">
        {/* <div className="PopupMainCon-BG-Blur"></div> */}

        <div className="PopUpTextCon AllADD">
          <div className="AllADD-T">
            Billing Address
            <img
              onClick={() => {
                props.setTrigger(false);
                try {
                  props.setTrigger2(false);
                } catch (error) {
                  // console.log('noTrigger2')
                }
              }}
              src={Cross}
              alt=''
            />
          </div>
          <div className="AllAddList">
            {Object.keys(Data).map((data) => {
              
              return (
                <div onClick={() => props.handleAddAddress(data)} className="AllADD-item">
                  <div className="rbtn">
                    <div
                      className="rbic"
                      onClick={() => setClicked(Data[data].id)}
                    ></div>
                  </div>
                  <div className="txtc">
                    <h3>{Data[data].Apt_no}</h3>
                    <h4>
                      {Data[data].Apt_no}, {Data[data].Street},{" "}
                      {Data[data].State}, {Data[data].Country},{Data[data].Zip}
                    </h4>
                  </div>
                </div>
              );
            })}
          </div>

          <div
            onClick={() => {
              try {
                props.setTrigger3(true);
              } catch (error) {
                // console.log('noTrigger2')
              }
            }}
            className="AllADD-new-add"
          >
            Add new address
          </div>
        </div>
        <div className="PopupBoxThird"></div>
      </div>
    </div>
  ) : (
    ""
  );
};

export default AllAddressPopup;
